<script lang="ts" setup>
    import type { CookieConsentServiceKey } from '../utils/cookieConsentServices';
    import { useUsercentricsConsent } from '../composables/useUsercentricsConsent';

    const props = defineProps<{
        serviceKey: CookieConsentServiceKey;
    }>();

    const { acceptConsent, hasConsent } = useUsercentricsConsent(props.serviceKey);
</script>

<template>
    <template v-if="hasConsent">
        <slot></slot>
    </template>
    <div
        v-else
        class="no-consent"
    >
        <div class="no-consent--inner">
            <ConsentMessage :service-key="serviceKey" />

            <PrimaryButton
                class="consent-button"
                :button-text="$t('genericCookieConsent.buttonTextNoConsent')"
                size="medium"
                @click="acceptConsent"
            />
        </div>

        <span
            class="grid-images grid-images--circle"
            aria-hidden="true"
        ></span>

        <span
            class="grid-images grid-images--blob"
            aria-hidden="true"
        ></span>
    </div>
</template>

<style scoped>
    .consent-button {
        margin-top: var(--spacing);
        margin-inline: auto;
        min-width: var(--spacing--16);
    }

    .no-consent {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: var(--cookie-consent-background-color, var(--brand-primary-30));
        position: relative;
        width: 100%;
        min-height: var(--spacing--24);
        height: auto;
        padding: var(--spacing--2) var(--spacing);
        overflow: hidden;
        border-radius: var(--border-radius-l);
    }

    .no-consent--inner {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        gap: var(--spacing);
        align-items: center;
    }

    .grid-images {
        position: absolute;
        z-index: 0;
        background-color: var(--cookie-consent-background-shape-color, var(--brand-primary-50));
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: contain;
        -webkit-mask-position: center;
        -webkit-mask-repeat: no-repeat;
        -webkit-mask-size: contain;
    }

    .grid-images--circle {
        width: 563px;
        height: 563px;
        left: -10%;
        top: 55%;
        mask-image: url('~/assets/images/hfp-grid-backgrounds/hfp-circle.svg');
        -webkit-mask-image: url('~/assets/images/hfp-grid-backgrounds/hfp-circle.svg');
    }

    .grid-images--blob {
        width: 648px;
        height: 709px;
        right: -25%;
        mask-image: url('~/assets/images/hfp-grid-backgrounds/hfp-blob.svg');
        -webkit-mask-image: url('~/assets/images/hfp-grid-backgrounds/hfp-blob.svg');
    }
</style>
